module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-31.0f9f0105.png";